import type { NotifyMe, NotifyRole, NotifySiteMembership } from "./types";

/** The site the app shows: the caller's first Notify site from `GET /me` (one
 * site per person in S1; a picker comes with more), or the one a link names. */
export function pickSite(me: NotifyMe | undefined, siteId?: string): NotifySiteMembership | null {
  const sites = me?.sites ?? [];
  if (siteId !== undefined) return sites.find((site) => site.site_id === siteId) ?? null;
  return sites[0] ?? null;
}

const has = (site: NotifySiteMembership, roles: NotifyRole[]) =>
  site.roles.some((role) => roles.includes(role));

/** Radiologists and admins read the case list and case details. */
export const canReadCases = (site: NotifySiteMembership) => has(site, ["radiologist", "admin"]);

/** Only radiologists acknowledge (become the owner). */
export const canAck = (site: NotifySiteMembership) => has(site, ["radiologist"]);

export const siteLabel = (site: NotifySiteMembership) => site.name || site.site_id;
